// ======================================================================
// File Name       : ContentDistributionUsageList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { Table } from 'react-bootstrap';
import {
  CONTENT_DISTRIBUTION_CONTENT_TYPE
} from '../../constants/ContentDistributionConstant';
import { getItemBoxName } from '../../utils/index';
import TableHead, { setSortState } from '../TableHead';

const ContentDistributionUsageList = ({ contentDistributionUsage, handleSortState, dataSort }) => {
  const thead = [
    { title: 'コンテンツ識別ID', sortBy: 0 },
    { title: 'コンテンツ種別', sortBy: 1 },
    { title: '配布コンテンツ名', sortBy: 2 },
    { title: '実行回数', sortBy: 3, width: 120 },
    { title: 'ユニーク実行ユーザー数', sortBy: 4 },
  ];
  let data = thead;
  if (dataSort) {
    const sortBy = dataSort.distributionUsedContentSortType;
    const sortState = dataSort.ascendingDescendingSort;
    data = setSortState(thead, sortBy, sortState);
  }

  const distributionServiceList =
    contentDistributionUsage && contentDistributionUsage.distributionContentList &&
    contentDistributionUsage.distributionContentList.map((contentDistribution, index) => (
      <tr key={index}>
        <td>{contentDistribution.contentSecernId}</td>
        <td>
          {getItemBoxName(CONTENT_DISTRIBUTION_CONTENT_TYPE, contentDistribution.contentType)}
        </td>
        <td>{contentDistribution.contentName}</td>
        <td className="text-right">{contentDistribution.usedCount}</td>
        <td className="text-right">{contentDistribution.uniqueUsedUserNum}</td>
      </tr>
    ));
  // }

  return (
    <div>
      <Table striped hover>
        <thead>
          <TableHead data={data} handleSortState={handleSortState} />
        </thead>
        <tbody>{distributionServiceList}</tbody>
      </Table>
    </div>
  );
};

export default ContentDistributionUsageList;
